import React, { useState } from 'react';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { getCsv } from '../../service/PaymentService';
import { useCompany } from '../../component/CompanySelection/CompanyContext';

import './Export.css';

export default function Export(props) {
    const [isLoading, setIsLoading] = useState(false);
    const { companyNumber } = useCompany();

    function handleOnClick() {
        setIsLoading(true);
        props.handleExport("info");

        // get Data
        getCsv(props.exportOptions, companyNumber, handleSuccess, handleError);
    }

    function handleSuccess() {
        setIsLoading(false);
    }

    function handleError() {
        props.handleExport("error");
        setIsLoading(false);
    }

    return (
        <div className="efup-export-button-wrapper" >
            {isLoading ? <div className="efup-export-loading cb-font-poppins" data-testid="efup-export-loading-wrapper">
                <LoadingSpinner blue testId='efup-export-loading-spinner' />
                <div className='efup-export-loading-text' data-testid="efup-export-loading-text">Data is Exporting.... </div>
            </div> : <button className="efup-export-btn" onClick={handleOnClick} data-testid="efup-export-button">
                <svg viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M16 11V18.1L13.9 16L11.1 18.8L8.3 16L11.1 13.2L8.9 11H16Z" />
                </svg>
                <div className="efup-export-button-text" data-testid="efup-export-button-text">Export</div>
            </button>}
        </div>
    )
}